import React from "react";

// Kit boxes (styles: src/styles/ui-kit.css .inyc-card / .inyc-panel). Pick by what the box is:
//   Card        a standalone item in a list / grid (posted event, template, venue, roster);
//               interactive = the whole card is clickable (search results), inverted = the picked item
//   Panel       a group inside a form or page (ticket tier, lineup slot, settings group, info box);
//               tone="danger|warning|success|info" for status boxes, dashed for empty states
//   OptionCard  a selectable choice (./OptionCard.jsx)
// All: radius xl, padding 16 (padding="sm": 12). Plain markup can use the classes directly.
const cls = (base, { padding, dashed, tone, interactive, inverted, className }) =>
  [base, padding === "sm" && "is-sm", dashed && "is-dashed", interactive && "is-interactive", inverted && "is-inverted", tone && tone !== "default" && `is-${tone}`, className].filter(Boolean).join(" ");

export const Card = ({ as: Tag = "div", padding = "md", interactive = false, inverted = false, className = "", children, ...rest }) => (
  <Tag className={cls("inyc-card", { padding, interactive, inverted, className })} {...rest}>
    {children}
  </Tag>
);

export const Panel = ({ as: Tag = "div", tone = "default", dashed = false, padding = "md", className = "", children, ...rest }) => (
  <Tag className={cls("inyc-panel", { padding, dashed, tone, className })} {...rest}>
    {children}
  </Tag>
);

export default Card;
